import { gql } from '@apollo/client';

// DD-3662 Marketplace: supplier connection requests.
const supplierRequestFields = `
    _id
    status
    message
    requestedByName
    requestedAt
    decidedAt
    declineReason
    requester { _id name organizationNumber city }
    supplier { _id name organizationNumber city }
`;

export const incomingSupplierRequestsTemplate = gql`
    query incomingSupplierRequests($status: SupplierConnectionRequestStatus) {
        incomingSupplierRequests(status: $status) {
            ${supplierRequestFields}
        }
    }
`;

export const outgoingSupplierRequestsTemplate = gql`
    query outgoingSupplierRequests($status: SupplierConnectionRequestStatus) {
        outgoingSupplierRequests(status: $status) {
            ${supplierRequestFields}
        }
    }
`;

export const requestSupplierConnectionTemplate = gql`
    mutation requestSupplierConnection($supplierId: MongoDbObjectId!, $message: String) {
        requestSupplierConnection(supplierId: $supplierId, message: $message) {
            ${supplierRequestFields}
        }
    }
`;

export const approveSupplierRequestTemplate = gql`
    mutation approveSupplierRequest($requestId: MongoDbObjectId!) {
        approveSupplierRequest(requestId: $requestId) {
            ${supplierRequestFields}
        }
    }
`;

export const declineSupplierRequestTemplate = gql`
    mutation declineSupplierRequest($requestId: MongoDbObjectId!, $reason: String) {
        declineSupplierRequest(requestId: $requestId, reason: $reason) {
            ${supplierRequestFields}
        }
    }
`;

// DD-3662 supplier browser.
export const supplierDirectoryTemplate = gql`
    query supplierDirectory(
        $search: SearchString
        $services: [SupplierService!]
        $sort: SupplierDirectorySort
        $maxDistanceKm: Int
        $hideConnected: Boolean
        $onlyLocated: Boolean
        $limit: Int
        $offset: Int
    ) {
        supplierDirectory(
            search: $search
            services: $services
            sort: $sort
            maxDistanceKm: $maxDistanceKm
            hideConnected: $hideConnected
            onlyLocated: $onlyLocated
            limit: $limit
            offset: $offset
        ) {
            total
            ownLocationKnown
            labs {
                _id
                name
                organizationNumber
                street
                zip
                city
                phone
                email
                website
                logoSignedUrl
                staffSignedUrl
                geoLocation {
                    latitude
                    longitude
                }
                services
                otherService
                description
                distanceKm
                connection
            }
        }
    }
`;
